import { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { useCssHandles } from '../../../../utils/functions';

type FilterNavigatorV3ContentProps = {
	isOpen: boolean;
	setIsOpen: Dispatch<SetStateAction<boolean>>;
};

const CSS_HANDLES = [
	'orderBy',
	'orderByDropdown',
	'orderByButton',
	'filterPopupTitle',
	'orderByText',
	'filterPopupArrowIcon',
	'caretIcon',
	'orderByOptionsContainer',
	'orderByOptionItem',
] as const;

const Content = ({ isOpen, setIsOpen }: FilterNavigatorV3ContentProps) => {
	const [display, setDisplay] = useState('dn');
	const { handles, withModifiers }: any = useCssHandles(`vtex-search-result-3-x`, CSS_HANDLES);
	const orderByLayoutClasses = withModifiers('orderBy', 'layout');
	const orderByOptionItemClasses = withModifiers('orderByOptionItem', 'selected');

	useEffect(() => {
		console.log(display);
		isOpen ? setDisplay('') : setDisplay('dn');
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [isOpen]);

	return (
		<div className={`${orderByLayoutClasses}`}>
			<div className={`${handles.orderByDropdown} relative pt1 justify-end w-100 w-auto-ns ml-auto`}>
				<button
					className={`${handles.orderByButton} ph3 pv5 mv0 pointer flex items-center justify-end bg-base c-on-base t-action--small bt br bl bb-0 br2 br--top bw1 w-100 outline-0 b--transparent pl1`}
					onClick={() => setIsOpen(!isOpen)}
				>
					<span className={`${handles.filterPopupTitle} c-on-base t-action--small ml-auto-ns`}>
						<span className={`${handles.orderByText}  c-muted-2 dn dib-ns`}>Ordenar Por: </span>
						Relevância
					</span>
					<span className={`${handles.filterPopupArrowIcon} ph5 pt1`}>
						<svg
							fill="none"
							width="10"
							height="10"
							viewBox="0 0 16 16"
							className={`${handles.caretIcon}`}
							xmlns="http://www.w3.org/2000/svg"
							xmlnsXlink="http://www.w3.org/1999/xlink"
						>
							<use href="#nav-caret--down" xmlnsXlink="#nav-caret--down"></use>
						</svg>
					</span>
				</button>
				<div
					className={`${handles.orderByOptionsContainer} z-3 absolute bg-base shadow-5 w-100 f5 b--muted-4 br2 ba bw1 br--bottom top-0 right-0-ns ${display}`}
				>
					<button
						className={`bg-light-gray ${orderByOptionItemClasses} c-on-base f5 ml-auto db no-underline pointer tl bn pv4 ph5 w-100 right-0-ns`}
						onClick={() => setIsOpen(!isOpen)}
					>
						Relevância
					</button>
					<button
						className={`hover-bg-muted-5 bg-base ${handles.orderByOptionItem}  c-on-base f5 ml-auto db no-underline pointer tl bn pv4 ph5 w-100 right-0-ns`}
						onClick={() => setIsOpen(!isOpen)}
					>
						Mais Vendidos
					</button>
					<button
						className={`hover-bg-muted-5 bg-base ${handles.orderByOptionItem}  c-on-base f5 ml-auto db no-underline pointer tl bn pv4 ph5 w-100 right-0-ns`}
						onClick={() => setIsOpen(!isOpen)}
					>
						Mais recentes
					</button>
					<button
						className={`hover-bg-muted-5 bg-base ${handles.orderByOptionItem}  c-on-base f5 ml-auto db no-underline pointer tl bn pv4 ph5 w-100 right-0-ns`}
						onClick={() => setIsOpen(!isOpen)}
					>
						Descontos
					</button>
					<button
						className={`hover-bg-muted-5 bg-base ${handles.orderByOptionItem}  c-on-base f5 ml-auto db no-underline pointer tl bn pv4 ph5 w-100 right-0-ns`}
						onClick={() => setIsOpen(!isOpen)}
					>
						Maior preço
					</button>
					<button
						className={`hover-bg-muted-5 bg-base ${handles.orderByOptionItem}  c-on-base f5 ml-auto db no-underline pointer tl bn pv4 ph5 w-100 right-0-ns`}
						onClick={() => setIsOpen(!isOpen)}
					>
						Menor preço
					</button>
					<button
						className={`hover-bg-muted-5 bg-base ${handles.orderByOptionItem}  c-on-base f5 ml-auto db no-underline pointer tl bn pv4 ph5 w-100 right-0-ns`}
						onClick={() => setIsOpen(!isOpen)}
					>
						De A a Z
					</button>
					<button
						className={`hover-bg-muted-5 bg-base ${handles.orderByOptionItem}  c-on-base f5 ml-auto db no-underline pointer tl bn pv4 ph5 w-100 right-0-ns`}
						onClick={() => setIsOpen(!isOpen)}
					>
						De Z a A
					</button>
				</div>
			</div>
		</div>
	);
};

export default Content;
